import { Button } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";

/**
 * @param {import("@mantine/core").ButtonProps} props
 */
export default function DeleteActionButton(props) {
	return (
		<Button variant="outline" color="red" leftSection={<IconTrash />} {...props}>
			Eliminar
		</Button>
	);
}
